import React, {useEffect, useState} from 'react'
import {ProductBadges} from '../product'
import {Eyebrow} from '@/components/ui/eyebrow'
import {ProductFavoritesButton} from '../product'
import {useProductContext} from 'hec/context/ProductContext'
import useMediaQuery from '@/hooks/useMediaQuery'

interface ProductTileImageProps {
    badges?: string[]
    enableQuickView?: boolean
    lmnBadgeColor?: string
    isLMNProduct?: boolean
}

export const ProductTileImage: React.FC<ProductTileImageProps> = ({
    badges,
    enableQuickView = true,
    lmnBadgeColor,
    isLMNProduct
}) => {
    const isSm = useMediaQuery('sm')
    const isMd = useMediaQuery('md')
    const isMobile = isSm || isMd
    const isTablet = useMediaQuery('lg')
    const [showQuickview, setShowQuickview] = useState(false)
    const {product, productImageSrc, setQuickviewModalOpen, setProductIdToFetch} =
        useProductContext()

    useEffect(() => {
        if (isTablet || isMobile) {
            setShowQuickview(true)
        }
    }, [isTablet, isMobile])

    if (!product) return null

    const {name, url, id} = product

    // Prefetch default variant data for master products on hover/focus
    const handlePrefetchVariant = () => {
        if (
            product?.type?.master &&
            product.variation_id &&
            product.variation_id !== product.id // only if not already the default
        ) {
            setProductIdToFetch?.(product.variation_id)
        } else {
            setProductIdToFetch?.(product.id)
        }
    }

    return (
        <div
            className="relative aspect-square"
            role="button"
            tabIndex={0}
            onMouseEnter={() => {
                if (!isTablet && enableQuickView) {
                    setShowQuickview(true)
                }
            }}
            onClick={() => {
                handlePrefetchVariant()
            }}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    handlePrefetchVariant()
                }
            }}
            onMouseLeave={() => !isTablet && enableQuickView && setShowQuickview(false)}
        >
            <ProductBadges
                badges={badges}
                productId={id}
                lmnBadgeColor={lmnBadgeColor}
                isLMNProduct={isLMNProduct}
                data-testid="productTileImage-ProductBadges"
            />
            <ProductFavoritesButton data-testid="productTileImage-ProductFavoritesButton" />
            <a href={url}>
                <img className="rounded" alt={name} src={productImageSrc} />
            </a>
            {showQuickview && enableQuickView && (
                <button
                    className="text-sm absolute bottom-0 bg-[#cccccc] w-full flex items-center justify-center"
                    title="Quick View"
                    onClick={(e) => {
                        e.preventDefault()
                        setQuickviewModalOpen(true)
                        setProductIdToFetch?.(product.id)
                    }}
                >
                    <Eyebrow
                        className="text-xs py-1 w-full"
                        data-testid="productTileImage-Eyebrow"
                        type="text"
                    >
                        QUICK VIEW
                    </Eyebrow>
                </button>
            )}
        </div>
    )
}
